import React from "react";
import kosmoLogo from "images/kosmofi/kosmofi_logo.svg";

const KosmofiHeader = () => {
  return (
    <div className="bg-white transition-all duration-300 ease-in-out pl-6 py-3 md:pl-20 md:py-6">
      <img
        src={kosmoLogo}
        alt="Kosmofi Logo"
        className="transition-all duration-300 ease-in-out"
      />
    </div>
  );
};

export default KosmofiHeader;
